import languages from "../languages/en-US/index";
import menu from "./en-US/menu";

export default {
  ...menu,
  ...languages,
};
